export enum Variant {
  Default = "default",
  Style = "style",
}
